import { Component, OnInit } from '@angular/core';
//import { Router } from '@angular/router';
import { SuprsendService } from '../suprsend-notification/suprsend.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DurationRangeService } from '@app-core/services/duration-range/duration-range.service';
import { AccessService } from '@app-core/services/access/access.service';
import { DataService } from '@app-core/services/data/data.service';
import { CLIENT_CONFIG } from '@config/config';
import { navigationRoutes as BaseLinks, RouteParams } from '@config/links.base';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-bottom-navigation',
  templateUrl: './bottom-navigation.component.html',
  styleUrls: ['./bottom-navigation.component.scss'],
})
export class BottomNavigationComponent implements OnInit {
  public mobileAppNavigationRoutes: RouteParams[] = CLIENT_CONFIG.allowedMobileRoutes.map((x) => BaseLinks[x]);
  public navigationRoutes = [...this.mobileAppNavigationRoutes];
  public isMobile = true; // Adjust based on your mobile breakpoint
  public user_distinct_id: string;
  public user_subscriberId: string;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  public canShowNotifcationIcon: boolean = false;
  public selectedTheme: string;
  public currentLanguage: string;
  public isFaqOpened = false;
  public featureId: string;

  constructor(
    private suprsendService: SuprsendService,
    public durationService: DurationRangeService,
    private accessService: AccessService,
    private dataService: DataService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    const { loginType = '' } = this.accessService.getLoginInfo();
    this.canShowNotifcationIcon = !this.durationService?.disableSuprsendNotification && loginType === 'fleetmanager';

    this.dataService._currentLanguage.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.currentLanguage = value;
        this.translate.use(value);
      }
    });

    this.dataService._currentTheme.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      this.selectedTheme = value;
    });

    this.dataService._currentFeatureFaq.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value: string) => {
      if (value) {
        this.featureId = value;
        this.isFaqOpened = true;
      }
    });
    this.getdistinctId();
  }

  private getdistinctId() {
    this.suprsendService
      .getsuprsendDistinctId()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: any) => {
          this.user_distinct_id = res.distinct_id || '';
          this.user_subscriberId = res.subscriberId || '';
        },
        (error) => {
          console.log('Error fetching distinct ID:', error);
          this.user_distinct_id = '';
          this.user_subscriberId = '';
        }
      );
  }

  public closeFaq() {
    this.isFaqOpened = false;
    this.featureId = null;
    this.dataService.currentFeatureFaq = null;
  }
}
